import ComponentCard from "../../components/common/ComponentCard";
import PostListComponent from "../../components/post/PostListComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

const PostList = () => {
    return (
        <>
            <PageMeta title="Danh sách bài viết" description="Trang danh sách bài viết"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <PostListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default PostList;